/* Lakhovsky Disc pre-sell pages (step 14, brand-03). Hand-written.
   1. Per ad concept (the LST; the ADV moved to the first screen per angle, ev-hero, on 2026-10-29): the
      concept code is read anywhere in ad_name (sp_LKD-B01_C04_…), else utm_term (sp_LKD-B01//C04-…), else
      utm_content. Every element carrying data-c04 takes that text; default = as written.
   2. Every link to the product page (a[data-pdp]) keeps the visitor's whole query string
      (UTMs, ad_name, fbclid, Whop click ids).
   3. A click on one of them publishes lp_cta_click (page, link position, concept, the angle ev-hero showed) for the
      page → product page click-through (target ≥ 35 %).
   4. The launch gifts' end (.js-deadline, written "Sunday"): the Sunday of the current week in New York,
      today on a Sunday, as the product page shows it (rolling; William, 2026-10-29). */
(function () {
  var q = new URLSearchParams(location.search);
  var src = [q.get('ad_name'), q.get('utm_term'), q.get('utm_content')].filter(Boolean).join(' ').toLowerCase();
  var m = src.match(/(?:^|[_\/\s])(c\d\d)(?=[a-z]?(?:[_\-\s]|$))/);
  var key = m ? m[1] : null;
  if (key) document.querySelectorAll('[data-' + key + ']').forEach(function (el) {
    var v = el.getAttribute('data-' + key);
    if (/</.test(v)) el.innerHTML = v; else el.textContent = v;
  });
  var dl = document.querySelectorAll('.js-deadline');
  if (dl.length) {
    var d;
    try { d = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' })); } catch (e) { d = new Date(); }
    d.setDate(d.getDate() + (7 - d.getDay()) % 7);
    var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var MONTH = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    dl.forEach(function (e) { e.textContent = DAYS[d.getDay()] + ', ' + MONTH[d.getMonth()] + ' ' + d.getDate(); });
  }
  var pass = [];
  q.forEach(function (v, k) { if (k !== 'variant') pass.push(encodeURIComponent(k) + '=' + encodeURIComponent(v)); });
  var page = document.body.getAttribute('data-lp') || 'lp';
  document.querySelectorAll('a[data-pdp]').forEach(function (a, i) {
    if (pass.length) a.href += (a.href.indexOf('?') > -1 ? '&' : '?') + pass.join('&');
    a.addEventListener('click', function () {
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('lp_cta_click', { page: page, link: i + 1, concept: key || 'default', angle: document.documentElement.getAttribute('data-angle') || 'default' }); } catch (e) {}
    });
  });
})();
